import styles from './card-body.module.scss';

export const CardBody = ({ children, ...props }) => {
  return (
    <section className={styles['card-body']} {...props}>
      {children}
    </section>
  );
};
